var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopify-collection-card",style:(_vm.style)},[_c('div',{staticClass:"image-container"},[(_vm.image_url)?_c('img',{attrs:{"src":_vm.image_url}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"style-body-bold text-center my-2"},[_vm._v(_vm._s(_vm.collection.title))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0ebc2f0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/views/rd/assets/js/v2/components/shopify/shopifyCollectionCard.vue
// module id = vk9t
// module chunks = 1 38 54